import axios from 'axios'

class UsersAPI {
  getStudents = async params => {
    return axios.get(`api/users/students`, {
      params,
    })
  }

  getEmployers = async params => {
    return axios.get(`api/users/employers`, {
      params,
    })
  }

  getMentors = async params => {
    return axios.get(`api/users/mentors`, {
      params,
    })
  }
}

export const usersAPI = new UsersAPI()
